"use strict";

var _defineProperty = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/defineProperty");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormItem = void 0;

var react_1 = __importDefault(require("react"));

var react_hook_form_1 = require("react-hook-form");

var Block_1 = require("../styled/Block");

var typography_1 = require("../typography");

function FormItem(_a) {
  var name = _a.name,
      label = _a.label,
      children = _a.children,
      defaultValue = _a.defaultValue,
      initialValue = _a.initialValue,
      style = _a.style,
      extra = _a.extra,
      valuePropName = _a.valuePropName,
      rules = __rest(_a, ["name", "label", "children", "defaultValue", "initialValue", "style", "extra", "valuePropName"]);

  var _ref = (0, react_hook_form_1.useController)({
    name: name,
    defaultValue: initialValue ? initialValue : defaultValue,
    rules: Object.assign(Object.assign({}, rules), {
      required: (rules === null || rules === void 0 ? void 0 : rules.required) === true ? 'This field is required.' : rules === null || rules === void 0 ? void 0 : rules.required
    })
  }),
      field = _ref.field,
      error = _ref.fieldState.error;

  var fieldError = error === null || error === void 0 ? void 0 : error.message;
  var cloned = react_1.default.cloneElement(children, Object.assign(Object.assign(Object.assign({}, field), valuePropName ? _defineProperty({}, valuePropName, field.value) : {}), {
    onChangeText: function onChangeText(value) {
      return field.onChange(value);
    }
  }));

  if (label || fieldError || extra) {
    return react_1.default.createElement(Block_1.VSpaced, {
      align: 'stretch',
      space: '@size-xs',
      style: style
    }, label ? react_1.default.createElement(typography_1.Body, {
      style: {
        alignSelf: 'flex-start'
      }
    }, label) : null, cloned, fieldError ? react_1.default.createElement(typography_1.BodySmall, {
      style: {
        alignSelf: 'flex-start'
      },
      color: '@red'
    }, fieldError) : null, extra ? react_1.default.createElement(typography_1.BodySmall, {
      color: '@text-color-secondary',
      useDiv: true
    }, extra) : null);
  } else return cloned;
}

exports.FormItem = FormItem;